"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

var _apolloClient = require("@/apollo/apolloClient");

var _moment = _interopRequireDefault(require("moment"));

var _constants = require("@/utils/constants");

var _suggestionQuery = require("@/apollo/queries/suggestion-query");

var _suggestionMutation = require("@/apollo/mutations/suggestion-mutation");

var _auth = require("@/utils/auth");

var state = {
  suggestions: [],
  suggestionById: [],
  page_count: 0,
  page_total: 0,
  searchText: '',
  suggestionCategories: [],
  showAllItem: false,
  category_id: null,
  suggestionComment: [],
  commentLimit: 10,
  commentTotal: 0
};
var mutations = {
  SET_SUGGESTION: function SET_SUGGESTION(state, val) {
    state.suggestions = val.map(function (item) {
      if (item.created_at) {
        item.created_at = (0, _moment.default)(String(item.created_at)).format('YYYY年MM月DD日 HH:mm');
      }

      if (item.category) {
        item.category = item.category.name;
      } else {
        item.category = '';
      }

      if (item.bulletin_surveys) {
        if (item.bulletin_surveys.length !== 0) {
          item.bulletin_survey = '有り';
        }
      } else {
        item.bulletin_survey = '';
      }

      if (item.user) {
        if (item.user.name && item.user.last_name) {
          item.name = item.user.last_name + ' ' + item.user.name;
        } else item.name = '';
      } else item.name = '';

      return item;
    });
  },
  CREATE_SUGGESTION_CATEGORIES_LIST: function CREATE_SUGGESTION_CATEGORIES_LIST(state, suggestionCategoryList) {
    if (!suggestionCategoryList) {
      if (suggestionCategoryList.length === 0) {
        return;
      }

      return;
    }

    function customNameCategory(nameInput) {
      return suggestionCategoryList.unshift({
        id: null,
        name: nameInput
      });
    }

    if (state.showAllItem) {
      customNameCategory('全てのカテゴリー');
    }

    state.suggestionCategories = suggestionCategoryList;
  },
  SET_SEARCH_TEXT: function SET_SEARCH_TEXT(state, val) {
    state.searchText = val;
  },
  SET_SUGGESTION_COUNT: function SET_SUGGESTION_COUNT(state, val) {
    state.page_count = val;
  },
  SET_CATEGORY_ID: function SET_CATEGORY_ID(state, val) {
    state.category_id = val;
  },
  CREATE_SUGGESTION_BY_ID: function CREATE_SUGGESTION_BY_ID(state, val) {
    if (val) {
      if (val.user) {
        val.name = val.user.last_name + ' ' + val.user.name;
      }
    }

    state.suggestionById = val;
  },
  SET_SHOW_ALL_ITEM: function SET_SHOW_ALL_ITEM(state, val) {
    state.showAllItem = val;
  },
  SET_SUGGESTION_COMMENTS: function SET_SUGGESTION_COMMENTS(state, val) {
    if (val) {
      state.suggestionComment = val.map(function (item) {
        if (item.user) {
          if (item.user.get_avatar_thumbnail) {
            item.avatar = item.user.get_avatar_thumbnail;
          }

          if (item.user.name && item.user.last_name) {
            item.fullName = item.user.last_name + ' ' + item.user.name;
          }

          if (item.user.uid) {
            item.user_uid = item.user.uid;
          }
        }

        if (item.updated_at) {
          item.comment_time = (0, _constants.commentTime)(item.updated_at);
        }

        return item;
      });
    }
  },
  SET_COMMENT_LIMIT: function SET_COMMENT_LIMIT(state, val) {
    state.commentLimit = val;
  }
};
var actions = {
  getSuggestionList: function () {
    var _getSuggestionList = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, searchText, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              searchText = null;

              if (state.searchText) {
                searchText = state.searchText.trim();
              }

              state.page_size = 30;
              _context.next = 6;
              return _apolloClient.apolloClient.query({
                query: _suggestionQuery.GET_SUGGESTION,
                variables: {
                  keyword: searchText,
                  page_limit: state.page_size,
                  page_offset: state.page_size * state.page_count,
                  categoryId: state.category_id
                }
              });

            case 6:
              res = _context.sent;

              if (res.data) {
                state.page_total = res.data.suggestions_count.aggregate.count === 0 ? 0 : Math.ceil(res.data.suggestions_count.aggregate.count / state.page_size) - 1;
              }

              commit('SET_SUGGESTION', res.data.suggestions);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getSuggestionList(_x) {
      return _getSuggestionList.apply(this, arguments);
    }

    return getSuggestionList;
  }(),
  getSuggestionCategories: function () {
    var _getSuggestionCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return _apolloClient.apolloClient.query({
                query: _suggestionQuery.GET_SUGGESTION_CATEGORIES
              });

            case 3:
              res = _context2.sent;

              if (!res.data) {
                _context2.next = 9;
                break;
              }

              commit('CREATE_SUGGESTION_CATEGORIES_LIST', res.data.suggestionCategories);
              return _context2.abrupt("return", res.data.suggestionCategories);

            case 9:
              throw res.errors[0].message;

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getSuggestionCategories(_x2) {
      return _getSuggestionCategories.apply(this, arguments);
    }

    return getSuggestionCategories;
  }(),
  insertSuggestionUserRead: function () {
    var _insertSuggestionUserRead = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, suggestionId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              _context3.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.ADD_SUGGESTION_USER,
                variables: {
                  suggestion_id: suggestionId
                }
              });

            case 3:
              res = _context3.sent;

              if (!res.data) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function insertSuggestionUserRead(_x3, _x4) {
      return _insertSuggestionUserRead.apply(this, arguments);
    }

    return insertSuggestionUserRead;
  }(),
  getSuggestionById: function () {
    var _getSuggestionById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref4) {
      var commit, idSuggestion, res;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              _context4.next = 3;
              return (0, _auth.getIdEditPage)();

            case 3:
              idSuggestion = _context4.sent;
              _context4.next = 6;
              return _apolloClient.apolloClient.query({
                query: _suggestionQuery.GET_SUGGESTION_BY_ID,
                variables: {
                  id: idSuggestion
                }
              });

            case 6:
              res = _context4.sent;
              commit('CREATE_SUGGESTION_BY_ID', res.data.suggestion);

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function getSuggestionById(_x5) {
      return _getSuggestionById.apply(this, arguments);
    }

    return getSuggestionById;
  }(),
  insertSuggestionCategories: function () {
    var _insertSuggestionCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref5, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              _context5.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.ADD_SUGGESTION_CATEGORIES,
                variables: {
                  name: data
                }
              });

            case 3:
              res = _context5.sent;

              if (!res.data) {
                _context5.next = 8;
                break;
              }

              return _context5.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function insertSuggestionCategories(_x6, _x7) {
      return _insertSuggestionCategories.apply(this, arguments);
    }

    return insertSuggestionCategories;
  }(),
  updateSuggestionCategories: function () {
    var _updateSuggestionCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(_ref6, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              _context6.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.UPDATE_SUGGESTION_CATEGORIES_BY_ID,
                variables: {
                  id: data.id,
                  name: data.name
                }
              });

            case 3:
              res = _context6.sent;

              if (!res.data) {
                _context6.next = 8;
                break;
              }

              return _context6.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function updateSuggestionCategories(_x8, _x9) {
      return _updateSuggestionCategories.apply(this, arguments);
    }

    return updateSuggestionCategories;
  }(),
  deleteCategoryAndUpdateSuggestionCategoryById: function () {
    var _deleteCategoryAndUpdateSuggestionCategoryById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(_ref7, categoryId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref7.commit;
              _context7.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.DELETE_CATEGORY_AND_UPDATE_SUGGESTION_CATEGORY_BY_ID,
                variables: {
                  category_id: categoryId
                }
              });

            case 3:
              res = _context7.sent;

              if (!res.data) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function deleteCategoryAndUpdateSuggestionCategoryById(_x10, _x11) {
      return _deleteCategoryAndUpdateSuggestionCategoryById.apply(this, arguments);
    }

    return deleteCategoryAndUpdateSuggestionCategoryById;
  }(),
  insertSuggestionComment: function () {
    var _insertSuggestionComment = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(_ref8, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref8.commit;
              _context8.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.INSERT_SUGGESTION_COMMENT,
                variables: {
                  comment: data.comment,
                  suggestion_id: data.suggestion_id
                }
              });

            case 3:
              res = _context8.sent;

              if (!res.errors) {
                _context8.next = 8;
                break;
              }

              throw res.errors[0].message;

            case 8:
              return _context8.abrupt("return", res.data);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function insertSuggestionComment(_x12, _x13) {
      return _insertSuggestionComment.apply(this, arguments);
    }

    return insertSuggestionComment;
  }(),
  getSuggestionComments: function () {
    var _getSuggestionComments = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(_ref9, form) {
      var commit, state, res;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref9.commit, state = _ref9.state;
              _context9.next = 3;
              return _apolloClient.apolloClient.query({
                query: _suggestionQuery.GET_SUGGESTION_COMMENTS,
                variables: {
                  suggestion_id: form.suggestion_id,
                  limit: state.commentLimit
                }
              });

            case 3:
              res = _context9.sent;
              state.commentTotal = res.data.suggestion_comments_aggregate.aggregate.count;
              commit('SET_SUGGESTION_COMMENTS', res.data.suggestion_comments);

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function getSuggestionComments(_x14, _x15) {
      return _getSuggestionComments.apply(this, arguments);
    }

    return getSuggestionComments;
  }(),
  deleteCommentById: function () {
    var _deleteCommentById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10(_ref10, commentId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              commit = _ref10.commit;
              _context10.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.DELETE_COMMENT_BY_ID,
                variables: {
                  comment_id: commentId
                }
              });

            case 3:
              res = _context10.sent;

              if (!res.data) {
                _context10.next = 8;
                break;
              }

              return _context10.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function deleteCommentById(_x16, _x17) {
      return _deleteCommentById.apply(this, arguments);
    }

    return deleteCommentById;
  }(),
  updateCommentById: function () {
    var _updateCommentById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee11(_ref11, item) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              commit = _ref11.commit;
              _context11.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _suggestionMutation.UPDATE_COMMENT_BY_ID,
                variables: {
                  commentId: item.commentId,
                  comment: item.comment
                }
              });

            case 3:
              res = _context11.sent;

              if (!res.data) {
                _context11.next = 8;
                break;
              }

              return _context11.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function updateCommentById(_x18, _x19) {
      return _updateCommentById.apply(this, arguments);
    }

    return updateCommentById;
  }()
};
var _default = {
  namespaced: true,
  mutations: mutations,
  state: state,
  actions: actions
};
exports.default = _default;